import React, { useRef } from "react";
import Modal from "@/common/elements/Modal";
import AddVisitor, { MODE } from "../AddVisitor";

const EditVisitorModal = ({ show, onHide, initialData, isBookings }) => {
  const childRef = useRef(null);

  const onModalHide = () => {
    onHide();
  };

  const onSaveChanges = () => {
    if (childRef.current) {
      childRef.current.save();
    }
  };

  return (
    <Modal
      show={show}
      onHide={onModalHide}
      header="Modify Visitor Information"
      size="xl"
      footerActions={
        !isBookings
          ? [
              {
                key: "save",
                text: "Save Changes",
                onClick: onSaveChanges,
              },
            ]
          : []
      }
      footerCloseAction
      footerCloseActionText="Close"
      scrollable
    >
      <AddVisitor mode={MODE.EDIT} initialData={initialData} ref={childRef} onHide={onHide} isBookings={isBookings}/>
    </Modal>
  );
};

export default EditVisitorModal;
